module.exports = __webpack_public_path__ + "static/average-american-debt-2-4b6bc4bffbde013e1690cb14b98a6e0c.png";